module.exports = __webpack_public_path__ + "img/logo.8c67a5f8.svg";